import React from "react";
import Navbar from "../components/Navbar";
import HeaderInner from "../components/HeaderInner";
import InnerPageSection from "../components/InnerPageSection";

function Auckland() {
  return (
    <div>
      <Navbar />
     <HeaderInner title="Truck Wreckers Auckland" />

      {/* Section 1 */}
      <InnerPageSection
        title="Truck Wreckers Auckland"
        paragraphs={[
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          "We offer top cash for trucks and fast removals.",
          "Our Auckland yard dismantles all makes and models.",
        ]}
        images={["images/inner-img.jpg", "images/inner-img.jpg"]}
      />

      {/* Section 2 */}
      <InnerPageSection
        title="Truck Wreckers Service Areas"
        paragraphs={[
          "We cover all major areas in and around Auckland.",
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        ]}
        listItems={[
        
          "Truck Wreckers Manukau South Auckland",
          "Truck Wreckers Pukekohe",
          "Best Truck Wreckers Auckland City",
          "Isuzu Truck Wreckers Waitakere West Auckland",
          "Truck Wreckers Albany",
          "Top Truck Wreckers Helensville",
          "Truck Wreckers Warkworth, Wellsford Northland",
        ]}
      />

      {/* Section 3 */}
      <InnerPageSection
        title="Wrecking & Dismantling For All Trucks"
        paragraphs={[
          "We dismantle all Japanese and European trucks with care.",
        ]}
        listItems={[
          "Hino", "Volvo", "Fuso", "Mack", "Nissan UD", "Isuzu", "Ford"
        ]}
      />
    </div>
  );
}

export default Auckland;
